"use client";

import { FC } from "react";
import Image from "next/image";
import { Button } from "@workspace/ui/components";

type ReadyToJoinCardProps = {
  onReady: () => void;
  variant: "desktop" | "mobile";
};

export const ReadyToJoinCard: FC<ReadyToJoinCardProps> = ({
  onReady,
  variant,
}) => {
  if (variant === "desktop") {
    return (
      <div className="hidden md:flex w-full xl:max-w-[960px] bg-white border border-[#e3d8c4] border-solid items-start p-[24px] rounded-[24px] shadow-[0px_4px_4px_0px_rgba(41,37,36,0.12)]">
        <div className="flex flex-1 gap-[40px] items-center">
          <div className="flex flex-1 gap-[24px] items-center">
            <div className="bg-[#fff3dc] border border-[#f5d3a5] border-solid flex flex-col items-center justify-center p-[12px] rounded-[12px] shadow-[3px_3px_0px_0px_#f5d3a5] shrink-0">
              <Image src="/icons/play.svg" alt="Play" width={24} height={24} />
            </div>
            <div className="flex flex-1 flex-col gap-[6px] items-start justify-center">
              <p className="capitalize font-medium leading-[22px] text-[#292524] text-[18px] w-full">
                Ready to Join?
              </p>
              <p className="font-medium leading-[22px] text-[#797268] text-[16px] w-full">
                Make sure you check your audio and video before starting.
              </p>
            </div>
          </div>
          <Button onClick={onReady} variant="d-primary" className="h-12 px-5">
            {`I'm Ready!`}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-20">
      <div className="bg-white border-[#e3d8c4] border-l border-r border-solid border-t flex flex-col items-start pb-[12px] pt-[20px] px-[20px] rounded-tl-[24px] rounded-tr-[24px]">
        <div className="flex flex-col gap-[20px] items-start w-full">
          <p className="font-semibold leading-[28px] text-[#292524] text-[20px] text-center w-full">
            Ready to join?
          </p>
          <div className="flex flex-col gap-[12px] items-center w-full">
            <Button
              onClick={onReady}
              variant="d-primary"
              className="h-12 px-5 w-full"
            >
              {`I'm Ready!`}
            </Button>
            <p className="font-normal leading-[16px] text-[#797268] text-[13px] text-center w-[205px]">
              Make sure you check your audio and video before starting.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white h-[34px] w-full" />
    </div>
  );
};
